import { useState, useEffect } from "react";
import { MOBILE_BREAKPOINT } from "../constants";

export const UseResponsiveStatus = () => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth > MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth > MOBILE_BREAKPOINT);
    };

    window.addEventListener("resize", ()=>{
      setTimeout(handleResize, 5000);
    });
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isMobile, setIsMobile };
};
